export const ROTAS_FISCAL = {
  MENU: '/main/fiscal/menu',
  GESTAO_NFSE: '/main/fiscal/gestao-nfse',
}

export const AVISO_MODELO_NACIONAL_NFSE =
  'A emissão da NFS-e municipal segue o modelo padrão nacional. Caso o município em que deseja emitir tenha alguma regra diferente ou exceção, entre em contato com o suporte.'

export const MENSAGEM_NFSE_ENVIADA =
  'NFS-e enviada para autorização. O status é atualizado sozinho; se demorar, use "Sincronizar Status" na 11.1.'

export const NFSE_STATUS = {
  PROCESSANDO: 'processando_autorizacao',
  AUTORIZADO: 'autorizado',
  ERRO_AUTORIZACAO: 'erro_autorizacao',
  CANCELADO: 'cancelado',
}

// Status em que a NFS-e ainda vale para a nota: bloqueia nova NFS-e e o CT-e da mesma nota
export const NFSE_STATUS_VIGENTES = [NFSE_STATUS.PROCESSANDO, NFSE_STATUS.AUTORIZADO]

export const NFSE_STATUS_OPTIONS = [
  { label: 'Autorizada', value: NFSE_STATUS.AUTORIZADO },
  { label: 'Processando', value: NFSE_STATUS.PROCESSANDO },
  { label: 'Erro ao Autorizar', value: NFSE_STATUS.ERRO_AUTORIZACAO },
  { label: 'Cancelada', value: NFSE_STATUS.CANCELADO },
]

export const TRIBUTACAO_ISS_TRIBUTAVEL = 1
export const TRIBUTACOES_ISS = [
  { value: 1, label: 'Operação tributável' },
  { value: 2, label: 'Imunidade' },
  { value: 3, label: 'Exportação de serviço' },
  { value: 4, label: 'Não incidência' },
]

export const RETENCAO_ISS_NAO_RETIDO = 1
export const TIPOS_RETENCAO_ISS = [
  { value: 1, label: 'Não retido' },
  { value: 2, label: 'Retido pelo tomador' },
  { value: 3, label: 'Retido pelo intermediário' },
]

export const AMBIENTES_NFSE = [
  { value: null, label: 'Não emite NFS-e' },
  { value: 'municipal', label: 'Municipal (sistema da prefeitura)' },
  { value: 'nacional', label: 'Nacional (Emissor Nacional)' },
]

export const OPCAO_SIMPLES_ME_EPP = 3
export const OPCOES_SIMPLES_NACIONAL = [
  { value: 1, label: 'Não optante' },
  { value: 2, label: 'Optante - MEI' },
  { value: 3, label: 'Optante - ME/EPP' },
]

export const REGIMES_APURACAO_SIMPLES = [
  { value: 1, label: 'Tributos federais e ISS pelo Simples Nacional' },
  { value: 2, label: 'Tributos federais pelo Simples e ISS fora dele' },
  { value: 3, label: 'Tributos federais e ISS fora do Simples Nacional' },
]

export const REGIMES_ESPECIAIS_TRIBUTACAO = [
  { value: 0, label: 'Nenhum' },
  { value: 1, label: 'Ato cooperado (cooperativa)' },
  { value: 2, label: 'Estimativa' },
  { value: 3, label: 'Microempresa municipal' },
  { value: 4, label: 'Notário ou registrador' },
  { value: 5, label: 'Profissional autônomo' },
  { value: 6, label: 'Sociedade de profissionais' },
  { value: 9, label: 'Outros' },
]

export const NFSE_TOMADOR_ORIGENS = [
  { value: 'empresa', label: 'Empresa cadastrada' },
  { value: 'cliente', label: 'Cliente cadastrado' },
  { value: 'tp', label: 'Operador Logístico cadastrado' },
  { value: 'manual', label: 'Preencher manualmente' },
]

export const MARCADORES_DESCRICAO_NFSE = [
  { marcador: '{notas}', descricao: 'números das notas fiscais' },
  { marcador: '{placa}', descricao: 'placa do veículo' },
  { marcador: '{data}', descricao: 'data de competência' },
  { marcador: '{empresa}', descricao: 'empresa das notas' },
]

export const LIMITE_DESCRICAO_NFSE = 1000
export const LIMITE_INFORMACOES_COMPLEMENTARES_NFSE = 2000
